module.exports = __webpack_public_path__ + "img/avatar.b3348ec.png";